/**
 * Compatibility hook providing the same API as next/navigation's useRouter.
 * This allows a zero-change migration for call sites (router.push, router.replace, etc).
 * Can be removed later by replacing with useNavigate directly.
 */
import { useMemo, useRef } from "react";
import { useNavigate } from "react-router-dom";

export function useRouter() {
  const navigate = useNavigate();
  // Store navigate in a ref so the returned object is referentially stable.
  // useNavigate() returns a new function on every location change, which would
  // break any useEffect([router]) dependency if we put it in useMemo deps.
  const navigateRef = useRef(navigate);
  navigateRef.current = navigate;

  return useMemo(
    () => ({
      push: (path: string) => navigateRef.current(path),
      replace: (path: string) => navigateRef.current(path, { replace: true }),
      back: () => navigateRef.current(-1),
      forward: () => navigateRef.current(1),
      refresh: () => window.location.reload(),
      prefetch: (_path: string) => {},
    }),
    [],
  );
}
